import { Row, Col } from "antd";
import { withTranslation } from "react-i18next";
import { ImgIcon } from "../../common/ImgIcon";
import Container from "../../common/Container";
import { SocialIcon } from 'react-social-icons';

import i18n from "i18next";
import {
  FooterSection,
  Title,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  Large,
  Chat,
  Empty,
  FooterContainer,
  Language,
  Label,
  LanguageSwitch,
  LanguageSwitchContainer,
} from "./styles";

interface SocialLinkProps {
  href: string;
  src: string;
}

const Footer = ({ t }: any) => {
  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  const SocialLink = ({ href, src }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
      >
        <ImgIcon src={src} width="25px" height="25px" />
      </a>
    );
  };

  return (
    <>
      <Extra>
        <Container border={true}>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingTop: "3rem" }}
          >
            <NavLink to="/">
              <LogoContainer>
                <ImgIcon
                  src="logo.svg"
                  aria-label="homepage"
                  width="101px"
                  height="64px"
                />
              </LogoContainer>
            </NavLink>
            <NavLink to="/">
              <Title>{t("Policy")}</Title>
            </NavLink>
  
            <FooterContainer style={{marginBottom: 20}}>
              <SocialIcon url="https://discord.gg/8nyVsQSGGs"/>
              <SocialIcon url="https://www.tiktok.com/@sheebnft"/>
              <SocialIcon url="https://www.instagram.com/sheebznft"/>
            </FooterContainer>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
